"use client";
import SelectInput from "@components/common/SelectInput";

const BlockRelationSelectComponent = ({ formData, setFormData, errors }) => {
	const handleBlockRelationChange = (id, value, name) => {
		setFormData(value);
	};
	return (
		<SelectInput
			id="is_block_related"
			dataTestId="block_related-select"
			label="Related to Block *"
			placeholder="Select Option"
			value={formData.is_block_related}
			onChange={handleBlockRelationChange}
			options={[
				{ id: "yes", name: "Yes", value: "yes" },
				{ id: "no", name: "No", value: "no" },
			]}
			displayField="name"
		/>
	);
};

export default BlockRelationSelectComponent;
